export default "__VITE_ASSET__SkNHabxT__"